module.exports = __webpack_public_path__ + "img/2gb-873.7443724b.png";